<script setup>
  import { ref, onMounted, watch, watchEffect} from 'vue';
  import { useI18n } from 'vue-i18n';
  import BaseModal from './base/BaseModal.vue';
  import ModalContentTextInput from '@/components/ModalContentTextInput.vue';
  
  const emits = defineEmits(['close']);

  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    },
  });

  const { t } = useI18n();

  const showModal = ref(false);

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  })

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="true"
    @close="closeModal"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">{{ t('containers.proForecast.spotForecastHelpTitle') }}</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <div class="jwx-modal__section-header">
          <h4 class="jwx-modal__section-title">{{ t('containers.proForecast.spotForecastHelpQuestion') }}</h4>
        </div>
        <div class="jwx-modal__section-body">
          <p class="jwx-modal__text">
            {{ t('containers.proForecast.spotForecastHelpAnswer') }}
          </p>
        </div>
      </div>
    </div>         
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          {{ t('common.close') }}
      </button>
      </div>
    </div>
  </BaseModal>
</template>